import { render } from "./ContentContainer.vue?vue&type=template&id=cc3ba980&scoped=true"
import script from "./ContentContainer.vue?vue&type=script&lang=js"
export * from "./ContentContainer.vue?vue&type=script&lang=js"

import "./ContentContainer.vue?vue&type=style&index=0&id=cc3ba980&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc3ba980"]])

export default __exports__